<script>
import { mapState } from 'vuex';

import { capitalize } from '@/helpers';
import { createDate } from '@/helpers/dates';

import './index.css';

export default {
  name: 'email-packet',
  props: {
    endDate: String,
    balance: Number,
    quantity: Number,
    startDate: String,
    packetLocalName: String
  },
  computed: {
    ...mapState({
      zoneOffset: state => state.userInfo && state.userInfo.zoneOffset
    }),
    getProgressBarWidth() {
      return `${(this.balance / this.quantity) * 100}%`;
    },
    getBalance() {
      return capitalize(this.$t('fe.email.packet.balance', [this.balance, this.quantity]));
    },
    getPeriod() {
      return capitalize(
        this.$t('fe.packet.period', [
          createDate(this.startDate).format('DD.MM.YYYY'),
          createDate(this.endDate).format('DD.MM.YYYY')
        ])
      );
    }
  }
};
</script>

<template>
  <div class="email-packet">
    <div class="email-packet__name">
      {{ $t(packetLocalName) | capitalize }}
    </div>
    <div class="email-packet__progress">
      <div class="email-packet__bar" :style="{ width: getProgressBarWidth }" />
    </div>
    <div class="email-packets__balance">
      {{ getBalance }}
    </div>
    <div class="email-packets__period" v-if="endDate">
      {{ getPeriod }}
    </div>
  </div>
</template>
